import { styled, type SxProps } from '@mui/material';
import React from 'react';

const Root = styled('div')(({ theme }) => ({
  backgroundColor: '#F0F4FA',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '8px',
  alignItems: 'center',
  padding: theme.spacing(8, 3),
  position: 'relative',
}));

const Value = styled('div')(({ theme }) => ({
  fontSize: '2.5rem',
  fontWeight: 700,
  lineHeight: '3.375rem',
  marginBottom: theme.spacing(1),
}));

const Label = styled('div')(() => ({
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
}));

const Divider = styled('hr')(({ theme }) => ({
  margin: theme.spacing(2, 0),
  width: '64px',
  height: '1px',
  border: 'none',
  backgroundColor: theme.palette.background.light,
}));

const Chip = styled('div')(({ theme }) => ({
  position: 'absolute',
  backgroundColor: theme.palette.text.default,
  color: 'white',
  padding: '5px 10px',
  borderRadius: '8px',
  top: -32,
}));

export type StatsCardProps = {
  sx?: SxProps;
};

export const StatsCard: React.FC<StatsCardProps> = ({ sx }) => {
  return (
    <Root sx={sx}>
      <Chip className="typography-v1-h3">2023</Chip>
      <Value>229 000+</Value>
      <Label>sjekket renten med Scoopr</Label>
      <Divider />
      <Value>147 MNOK</Value>
      <Label>i reduserte rentekostnader på kredittkort</Label>
      <Divider />
      <Value>103 MNOK</Value>
      <Label>i reduserte rentekostnader på forbrukslån</Label>
    </Root>
  );
};
